import React, { useMemo } from 'react';
import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { toZonedTime } from 'date-fns-tz';
import { TbSunHigh, TbSunset2 } from 'react-icons/tb';
import { useSelector } from 'react-redux';

import { getFormattedTime } from '../../account/settings/settings-helpers';
import { selectSite } from '../../site/siteSlice';
import { useGetSunriseSunsetQuery } from '../../site/sunriseSunsetApi';

export function SunriseSunset() {
  const { timezone } = useSelector(selectSite);
  const currentTime = toZonedTime(new Date(), timezone);
  const { data: sunTimes, isLoading } = useGetSunriseSunsetQuery(currentTime);
  const formattedTimes = useMemo(() => {
    if (sunTimes) {
      return {
        sunrise: getFormattedTime(new Date(sunTimes.sunrise)),
        sunset: getFormattedTime(new Date(sunTimes.sunset)),
      };
    }
  }, [sunTimes]);
  return (
    <Skeleton isLoaded={!isLoading}>
      <Flex alignItems="center" data-testid="sunrise-sunset-container">
        <TbSunHigh size={20} />
        <Text ml={1} mr={2}>
          {formattedTimes?.sunrise}
        </Text>
        <TbSunset2 size={20} />
        <Text ml={1} mr={2}>
          {formattedTimes?.sunset}
        </Text>
      </Flex>
    </Skeleton>
  );
}
